import { render, staticRenderFns } from "./EventLotto.vue?vue&type=template&id=62921f20&scoped=true"
import script from "./EventLotto.vue?vue&type=script&lang=js"
export * from "./EventLotto.vue?vue&type=script&lang=js"
import style0 from "./EventLotto.vue?vue&type=style&index=0&id=62921f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62921f20",
  null
  
)

export default component.exports